import { CaretakerQualification, QualificationSpecialty, QualificationType } from '../caretaker/caretaker.model'

const isUniversityQualification = (type: QualificationType) => type === QualificationType.universityEducation

const isProfessionalQualification = (type: QualificationType) =>
  type === QualificationType.jobTraining || 'Formación profesional'

const isUniversityOrProfessionalQualification = (type: QualificationType) =>
  isUniversityQualification(type) || isProfessionalQualification(type)

const isCourseQualification = (type: QualificationType) => type === QualificationType.course

const isOtherQualificationSpeciality = (specialty: QualificationSpecialty) => specialty === QualificationSpecialty.other

export const mapCaretakerQualification = (qualification: CaretakerQualification): string => {
  if (isCourseQualification(qualification.qualificationType) && qualification.qualificationName) {
    return `Curso - ${qualification.qualificationName}`
  }

  if (
    isCourseQualification(qualification.qualificationType) &&
    qualification.qualificationSpecialty &&
    !qualification.qualificationName
  ) {
    return `Curso - ${qualification.qualificationSpecialty}`
  }

  if (
    isUniversityOrProfessionalQualification(qualification.qualificationType) &&
    !isOtherQualificationSpeciality(qualification.qualificationSpecialty)
  ) {
    return qualification.qualificationSpecialty
  }

  if (
    isUniversityOrProfessionalQualification(qualification.qualificationType) &&
    isOtherQualificationSpeciality(qualification.qualificationSpecialty) &&
    qualification.qualificationName
  ) {
    return qualification.qualificationName
  }

  if (
    isUniversityOrProfessionalQualification(qualification.qualificationType) &&
    isOtherQualificationSpeciality(qualification.qualificationSpecialty) &&
    qualification.qualificationArea &&
    !qualification.qualificationName
  ) {
    return isUniversityQualification(qualification.qualificationType)
      ? `Formación universitaria :${qualification.qualificationArea}`
      : `Formación profesional :${qualification.qualificationArea}`
  }

  if (qualification.qualificationSpecialty && !isOtherQualificationSpeciality(qualification.qualificationSpecialty)) {
    return qualification.qualificationSpecialty
  }

  return ''
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/nursingHome.mapper.ts